
const getters = {
  listAll: state => {
    return state.client_list
  },
  getNetworks: state => {
    if (state.client_selected) {
      return state.client_selected.networks
    }
  },
  getSelected: state => {
    if (state.client_selected) {
      return state.client_selected
    }
  }
}
export default getters



//////////////////
// WEBPACK FOOTER
// ./state/client/client.getters.js
// module id = null
// module chunks = 